// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tab-bar {
  height: var(--tab-height);
  background: var(--bg-secondary);
  border-bottom: 1px solid var(--border);
  display: flex;
  align-items: stretch;
  flex-shrink: 0;
  overflow: hidden;
}

.tab-bar-toggle {
  width: 35px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-secondary);
  border-right: 1px solid var(--border);
  transition: color 0.1s, background 0.1s;
}
.tab-bar-toggle:hover { color: var(--text-primary); background: var(--bg-hover); }

.tab-list {
  display: flex;
  align-items: stretch;
  overflow-x: auto;
  flex: 1;
}
.tab-list::-webkit-scrollbar { height: 2px; }

.tab {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 12px 0 14px;
  cursor: pointer;
  border-right: 1px solid var(--border);
  white-space: nowrap;
  color: var(--text-secondary);
  font-size: 13px;
  transition: background 0.1s, color 0.1s;
  min-width: 100px;
}
.tab:hover { background: var(--bg-hover); color: var(--text-primary); }
.tab.active { background: var(--bg-primary); color: var(--text-primary); border-top: 1px solid var(--accent-light); }
.tab-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  overflow: hidden;
  gap: 1px;
}
.tab-label { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; line-height: 1.2; }
.tab.preview .tab-label { font-style: italic; }
.tab-project-no { font-size: 10px; color: var(--text-secondary); line-height: 1; max-width: 140px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

.tab-close {
  flex-shrink: 0;
  width: 18px; height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  color: var(--text-muted);
  opacity: 0;
  transition: opacity 0.1s, background 0.1s;
}
.tab:hover .tab-close, .tab.active .tab-close { opacity: 1; }
.tab-close:hover { background: var(--bg-active); color: var(--text-primary); }

.tab-bar-mobile-title { display: none; }

@media (max-width: 768px), (hover: none) and (max-width: 1024px) {
  .tab-bar { height: 44px; }
  .tab-bar-toggle { width: 44px; height: 44px; }
  .tab-bar-mobile-title {
    display: flex; align-items: center; flex: 1;
    padding: 0 12px; font-size: 14px; font-weight: 500;
    color: var(--text-primary); overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
  }
  .tab-list { display: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/TabBar.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,sCAAsC;EACtC,aAAa;EACb,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,qCAAqC;EACrC,uCAAuC;AACzC;AACA,wBAAwB,0BAA0B,EAAE,2BAA2B,EAAE;;AAEjF;EACE,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,OAAO;AACT;AACA,+BAA+B,WAAW,EAAE;;AAE5C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,eAAe;EACf,qCAAqC;EACrC,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,uCAAuC;EACvC,gBAAgB;AAClB;AACA,aAAa,2BAA2B,EAAE,0BAA0B,EAAE;AACtE,cAAc,6BAA6B,EAAE,0BAA0B,EAAE,yCAAyC,EAAE;AACpH;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,OAAO;EACP,gBAAgB;EAChB,QAAQ;AACV;AACA,aAAa,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AAC/F,0BAA0B,kBAAkB,EAAE;AAC9C,kBAAkB,eAAe,EAAE,4BAA4B,EAAE,cAAc,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;;AAEnK;EACE,cAAc;EACd,WAAW,EAAE,YAAY;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,wBAAwB;EACxB,UAAU;EACV,yCAAyC;AAC3C;AACA,gDAAgD,UAAU,EAAE;AAC5D,mBAAmB,4BAA4B,EAAE,0BAA0B,EAAE;;AAE7E,wBAAwB,aAAa,EAAE;;AAEvC;EACE,WAAW,YAAY,EAAE;EACzB,kBAAkB,WAAW,EAAE,YAAY,EAAE;EAC7C;IACE,aAAa,EAAE,mBAAmB,EAAE,OAAO;IAC3C,eAAe,EAAE,eAAe,EAAE,gBAAgB;IAClD,0BAA0B,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB;EAC5F;EACA,YAAY,aAAa,EAAE;AAC7B","sourcesContent":[".tab-bar {\n  height: var(--tab-height);\n  background: var(--bg-secondary);\n  border-bottom: 1px solid var(--border);\n  display: flex;\n  align-items: stretch;\n  flex-shrink: 0;\n  overflow: hidden;\n}\n\n.tab-bar-toggle {\n  width: 35px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-secondary);\n  border-right: 1px solid var(--border);\n  transition: color 0.1s, background 0.1s;\n}\n.tab-bar-toggle:hover { color: var(--text-primary); background: var(--bg-hover); }\n\n.tab-list {\n  display: flex;\n  align-items: stretch;\n  overflow-x: auto;\n  flex: 1;\n}\n.tab-list::-webkit-scrollbar { height: 2px; }\n\n.tab {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 0 12px 0 14px;\n  cursor: pointer;\n  border-right: 1px solid var(--border);\n  white-space: nowrap;\n  color: var(--text-secondary);\n  font-size: 13px;\n  transition: background 0.1s, color 0.1s;\n  min-width: 100px;\n}\n.tab:hover { background: var(--bg-hover); color: var(--text-primary); }\n.tab.active { background: var(--bg-primary); color: var(--text-primary); border-top: 1px solid var(--accent-light); }\n.tab-text {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  flex: 1;\n  overflow: hidden;\n  gap: 1px;\n}\n.tab-label { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; line-height: 1.2; }\n.tab.preview .tab-label { font-style: italic; }\n.tab-project-no { font-size: 10px; color: var(--text-secondary); line-height: 1; max-width: 140px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n\n.tab-close {\n  flex-shrink: 0;\n  width: 18px; height: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 3px;\n  color: var(--text-muted);\n  opacity: 0;\n  transition: opacity 0.1s, background 0.1s;\n}\n.tab:hover .tab-close, .tab.active .tab-close { opacity: 1; }\n.tab-close:hover { background: var(--bg-active); color: var(--text-primary); }\n\n.tab-bar-mobile-title { display: none; }\n\n@media (max-width: 768px), (hover: none) and (max-width: 1024px) {\n  .tab-bar { height: 44px; }\n  .tab-bar-toggle { width: 44px; height: 44px; }\n  .tab-bar-mobile-title {\n    display: flex; align-items: center; flex: 1;\n    padding: 0 12px; font-size: 14px; font-weight: 500;\n    color: var(--text-primary); overflow: hidden; text-overflow: ellipsis; white-space: nowrap;\n  }\n  .tab-list { display: none; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
